export default "__VITE_ASSET__110b2ec8__"